import { http } from "./http";

const ENDPOINTS = {
  VENDOR_INVOICE: "/vendor-invoices/",
  VENDOR_INVOICE_ID: (id) => `/vendor-invoices/${id}/`,
  VENDOR_INVOICE_PREVIEW: "/vendor-invoices/preview-excel/",
  VENDOR_INVOICE_IMPORT: "/vendor-invoices/confirm-import/",
  VENDOR_INVOICES_VENDORS: "/vendor-invoices/vendors/",
  VENDOR_CATEGORY: "/vendor-invoices-categories/",
  VENDOR_CATEGORY_ID: (id) => `/vendor-invoices-categories/${id}/`,
  VENDOR_SUB_CATEGORY: "/vendor-invoices-sub-categories/",
  VENDOR_SUB_CATEGORY_ID: (id) => `/vendor-invoices-sub-categories/${id}/`,
  VENDOR_COST_TYPE: "/vendor-invoice-cost-types/",
  VENDOR_COST_TYPE_ID: (id) => `/vendor-invoice-cost-types/${id}/`,
  BUDGET: "/vendor-budgets/",
  BUDGET_ID: (id) => `/vendor-budgets/${id}/`,
  COST_REPORT: "/cost-report/",
  COST_SUMMARY: "/cost-summary/",
};

export const vendorInvoiceAPI = {
  getAll: (params = {}) => http.get(ENDPOINTS.VENDOR_INVOICE, { params }),
  getById: (id) => http.get(ENDPOINTS.VENDOR_INVOICE_ID(id)),
  create: (data) => http.post(ENDPOINTS.VENDOR_INVOICE, data),
  update: (id, data) => http.patch(ENDPOINTS.VENDOR_INVOICE_ID(id), data),
  delete: (id) => http.delete(ENDPOINTS.VENDOR_INVOICE_ID(id)),
  previewImport: (formData) =>
    http.postFormData(ENDPOINTS.VENDOR_INVOICE_PREVIEW, formData),
  importVendors: (data) => http.post(ENDPOINTS.VENDOR_INVOICE_IMPORT, data),
  getAllVendors: (params = {}) => http.get(ENDPOINTS.VENDOR_INVOICES_VENDORS, { params: { ...params } }),
  getAllCategories: () => http.get(ENDPOINTS.VENDOR_CATEGORY),
  createCategory: (data) => http.post(ENDPOINTS.VENDOR_CATEGORY, data),
  updateCategory: (id, data) =>
    http.patch(ENDPOINTS.VENDOR_CATEGORY_ID(id), data),
  deleteCategory: (id) => http.delete(ENDPOINTS.VENDOR_CATEGORY_ID(id)),

  getAllSubCategories: () => http.get(ENDPOINTS.VENDOR_SUB_CATEGORY),
  createSubCategory: (data) => http.post(ENDPOINTS.VENDOR_SUB_CATEGORY, data),
  updateSubCategory: (id, data) =>
    http.patch(ENDPOINTS.VENDOR_SUB_CATEGORY_ID(id), data),
  deleteSubCategory: (id) => http.delete(ENDPOINTS.VENDOR_SUB_CATEGORY_ID(id)),

  getAllCostTypes: () => http.get(ENDPOINTS.VENDOR_COST_TYPE),
  createCostType: (data) => http.post(ENDPOINTS.VENDOR_COST_TYPE, data),
  updateCostType: (id, data) =>
    http.patch(ENDPOINTS.VENDOR_COST_TYPE_ID(id), data),
  deleteCostType: (id) => http.delete(ENDPOINTS.VENDOR_COST_TYPE_ID(id)),

  getCostReport: (projectId, phaseId = null, blockId = null) => {
    const params = { project_id: projectId };
    if (phaseId)  params.phase_id = phaseId;
    if (blockId)  params.block_id = blockId;
    return http.get(ENDPOINTS.COST_REPORT, { params });
  },

  getCostSummary: (phaseId = null) =>
    http.get(ENDPOINTS.COST_SUMMARY, {
      params: phaseId ? { phase: phaseId } : {},
    }),

  getBudgetsByPhase: (phaseId) =>
    http.get(ENDPOINTS.BUDGET, { params: { phase: phaseId } }),
  createBudget: (data) => http.post(ENDPOINTS.BUDGET, data),
  updateBudget: (id, data) => http.patch(ENDPOINTS.BUDGET_ID(id), data),
  deleteBudget: (id) => http.delete(ENDPOINTS.BUDGET_ID(id)),
};
